export enum PermissionableType {
  TEAM = 'team',
  USER = 'user'
}

export interface PermissionProps {
  permissionable_type: PermissionableType.TEAM | PermissionableType.USER;
  permissionable_id: number;
}

export interface Share {
  permissions: Permissionable[];
  invites: string[];
}

export interface Permissionable extends PermissionProps {
  name: string;
  disabled: boolean;
  isShareUser?: boolean;
}
